import React from "react";
import Task from "../../assets/task.png";
import Completed from "../../assets/checked.png";
import Pending from "../../assets/work-in-progress.png";
import Urgent from "../../assets/alarm.png";
import navigate from "../../assets/logo.png";
import start from "../../assets/start.png";
import phone from "../../assets/phone.png";

const Bookingdashboard = () => {
  return (
    <div className="px-6 md:px-10 py-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800">Today's Tasks</h1>
        <p className="text-gray-500">
          Overview of your task status and activities
        </p>
      </div>

      {/* Task Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {[
          { img: Task, label: "Total Tasks", count: 8 },
          { img: Completed, label: "Completed", count: 6 },
          { img: Pending, label: "Pending", count: 1 },
          { img: Urgent, label: "Urgent", count: 1 },
        ].map((item, i) => (
          <div
            key={i}
            className="rounded-xl bg-white shadow-md bg-white-50 border border-black text-center p-6 hover:shadow-lg transition-all"
          >
            <img className="h-10 mx-auto" src={item.img} alt={item.label} />
            <p className="text-2xl font-bold mt-4 text-gray-800">
              {item.count}
            </p>
            <h2 className="text-sm font-medium text-gray-600 mt-1">
              {item.label}
            </h2>
          </div>
        ))}
      </div>

      {/* Task Filter Buttons */}
      <div className="mt-12">
        <h2 className="text-xl font-semibold mb-4">Task Overview</h2>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
          {["All Tasks", "Delivery", "Pickup", "Completed", "Urgent"].map(
            (text, i) => (
              <button
                key={i}
                className="py-2 px-4 rounded-full hover:bg-blue-100 text-sm font-semibold border border-black mt-4 text-black transition"
              >
                {text}
              </button>
            )
          )}
        </div>
      </div>

      {/* Task Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
        {[1, 2, 3, 4, 5].map((_, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-lg p-6 border-l-4 border-[#27ae60] relative"
          >
            <span className="absolute top-4 right-4 bg-red-500 text-white text-xs px-2 py-1 rounded-full uppercase font-semibold">
              Urgent
            </span>

            <div className="flex justify-between items-center mb-3">
              <div className="text-sm font-semibold text-[#27ae60]">
                Delivery
              </div>
              <div className="text-sm text-gray-500">9:00 AM</div>
            </div>

            <div className="flex items-center gap-4 mb-4">
              <div>
                <h3 className="text-lg font-semibold">Toyota Camry 2024</h3>
                <p className="text-sm text-gray-600">
                  License: ABC-1234 • Rental ID: #R2024-001
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm my-8">
              <div>
                <h4 className="font-semibold mb-1">👤 Customer</h4>
                <p>John Smith</p>
                <p>📱 +1 (555) 123-4567</p>
                <p>✉️ john.smith@email.com</p>
              </div>
              <div>
                <h4 className="font-semibold mb-1">📍 Delivery Address</h4>
                <p>
                  123 Oak Street, Apt 4B
                  <br />
                  New York, NY 10001
                </p>
              </div>
            </div>

            <div className="flex flex-wrap justify-between gap-2 mt-5">
              <button title="Call Customer" className="px-4 py-2 rounded text-sm text-gray-700">
                <img src={phone} className="w-10 h-10" />
              </button>
              <button
                title="Navigate"
                className="px-4 py-2 rounded text-sm text-gray-700"
              >
                {/* 🗺️ Navigate */}
                <img src={navigate} className="w-10 h-10" />
              </button>
              <button
                title="Start Delivery"
                className="text-white px-4 py-2 rounded text-sm flex gap-2"
              >
                <img src={start} className="w-14 h-14" />{" "}
                <p className="text-black mt-4 text-md font-semibold">
                  Delivery
                </p>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Bookingdashboard;
